<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="account">Bank Account</label>
            <Dropdown v-model="account" :options="bankList"
                      optionLabel="name"
                      :filter=true
                      :showClear="true" id="account"
                      placeholder="Select Bank">
            </Dropdown>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button type="submit" @click.prevent="searchBankStatement" sty
                    class="p-button-raised" label="Search" icon="pi pi-search"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button
              v-if="this.bankStatementReportList.length > 0" @click.prevent="reset"
              class="p-button-raised p-button-warning" label="Reset" icon="pi pi-refresh"/>
          </div>
        </div>
      </form>
      <!-- DataTable for PartyStatement -->
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <a href="#" @click.prevent="exportCSV()" v-if="this.bankStatementReportList.length > 0">
            <img src="../../../../static/img/excel.png" style="float: right;height: 3em;width: 3em;"/>
          </a>
          <DataTable :value="bankStatementReportList"
                     :paginator="true"
                     :rowsPerPageOptions="[100,500,1000]"
                     :rows="100" :filters="filters"
                     class="p-datatable-responsive-demo p-datatable-gridlines"
                     data-key="id">
            <template #empty>No record found</template>
            <Column header="S.N">
              <template #body="sl">{{ sl.index + 1 }}</template>
            </Column>
            <Column :sortable="true" header="Miti" field="transactionDateNepali" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Date" field="transactionDate" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Vou Type" field="moduleType" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['moduleType']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Voucher" field="voucher" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['voucher']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Particulars" field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>
            </Column>

            <Column :sortable="true" header="Cheque Date" field="chequeDate" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['chequeDate']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Cheque Number" field="chequeNumber" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['chequeNumber']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Deposited" bodyStyle="color:#00a65a;text-align: right" field="debitBalance"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['debitBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Withdraw" bodyStyle="color:#dd4b39;text-align: right" field="creditBalance"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['creditBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Balance" bodyStyle="text-align: right"
                    field="closingBalance" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['closingBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Dr-Cr" bodyStyle="text-align: right"
                    field="drCr" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['drCr']"/>
              </template>
            </Column>

          </DataTable>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'

export default {
  data() {
    return {
      loading: false,
      fromDate: null,
      toDate: null,
      bankStatementReportList: [],
      bankList: [],
      account: '',
      accountMasterId: null,
      filters: {},
      englishDateEnabled: true
    }
  },
  mounted() {
    this.bank()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async bank() {
      let response = await this.$store.dispatch('loadBankList')
      this.bankList = response.data.data
    },
    async searchBankStatement() {
      if (this.account === '' || this.account === null) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please select at least one bank!', life: 3000})
        return
      }
      if (this.account === '') {
        this.accountMasterId = 0
      } else {
        this.accountMasterId = this.account.id
      }
      let bankStatementObject = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        bankId: this.accountMasterId
      }
      this.loading = true
      let response = await this.$store.dispatch('loadBankStatement', bankStatementObject)
      this.loading = false
      this.bankStatementReportList = response.data.data
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 3000})
      } else if (response.data.data.length > 0) {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.bankStatementReportList = []
      this.account = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    Dropdown,
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputMask,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// bankStatement.vue?1073c4da